var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"box"},_vm._l((_vm.kosaku),function(k,index){return _c('div',{key:index},[_c('browse-kosaku-view',{attrs:{"data":k.data,"imageUrl":k.imageUrl}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }